import React from 'react';

const HowToUse = () => (
  <div className="flex flex-col items-center justify-center min-h-screen bg-black text-white px-6 py-12" style={{ fontFamily: 'Inter, system-ui, sans-serif' }}>
    <div className="max-w-2xl w-full">
      <h1 className="text-3xl font-semibold mb-6 text-center tracking-wide">How to Use</h1>
      <div className="bg-gray-900/60 rounded-lg p-6 shadow-lg border border-gray-800">
        <p className="mb-4 text-base leading-relaxed">
          Our tool is user friendly and easy to navigate through. The user can upload the planet’s data through two methods by navigating to the <span className="font-medium text-blue-400">Calculate habitability</span> section:
        </p>
        <ul className="list-disc list-inside mb-4 text-base leading-relaxed space-y-2">
          <li>
            <span className="font-medium text-blue-400">Uploading a CSV file:</span> The user is required to organise the data in a particular format. It can then be uploaded into the application using the “UPLOAD CSV” button.
          </li>
          <li>
            <span className="font-medium text-blue-400">Filling the data manually:</span> The user can also fill the planet’s data into the space provided manually. Kindly keep in mind the units.
          </li>
        </ul>
        <p className="mb-4 text-base leading-relaxed">
          Once the input is given, the model will take a few seconds to analyse and give its results. The model gives the output in the form of percentage which is a direct representation of the habitability of the planet.
        </p>
        <p className="mb-2 text-base leading-relaxed font-semibold text-yellow-400">
          NOTE: If any data field is empty it can affect the accuracy of the model’s result.
        </p>
      </div>
    </div>
  </div>
);

export default HowToUse; 